var map = {
	"./Click+ Ofimática.png": 199,
	"./GlobalG.jpeg": 89212,
	"./HOMEOFF.jpg": 98935,
	"./Kueski/KueskiPay slogan_blanco.png": 24480,
	"./Kueski/KueskiPay slogan_colores.png": 79180,
	"./Kueski/KueskiPay+slogan_blanco.png": 63105,
	"./Kueski/KueskiPay+slogan_colores.png": 24947,
	"./Kueski/KueskiPay_blanco.png": 70220,
	"./Kueski/KueskiPay_colores.png": 8168,
	"./Kueski/KueskiPay_negro.png": 81014,
	"./Kueski/integracionKueski.png": 28613,
	"./Kueski/logoKueski.png": 88737,
	"./Kueski/merchantsResponse.png": 20796,
	"./LogoUvegBlanco.png": 94722,
	"./MOS.jpg": 58372,
	"./Mos.png": 34336,
	"./NuevosCertificados.png": 57985,
	"./SlideerAppMovilRelease.png": 70456,
	"./SmartClick.png": 81602,
	"./agenda-asesoria.png": 36251,
	"./analytics.jpg": 39275,
	"./asistenteVisualB.png": 44833,
	"./asistenteVisualB.webp": 63091,
	"./asistenteVisualBasic.png": 80241,
	"./atajos/administrador.png": 10561,
	"./atajos/administrador.webp": 73075,
	"./atajos/arcade.png": 30972,
	"./atajos/arcade.webp": 75778,
	"./atajos/asesorias.png": 24418,
	"./atajos/asesorias.webp": 44562,
	"./atajos/clickMovil.png": 92937,
	"./atajos/clickMovil.webp": 98765,
	"./atajos/continuar.png": 4533,
	"./atajos/continuar.webp": 49507,
	"./atajos/diagnostico.png": 13094,
	"./atajos/diagnostico.webp": 76430,
	"./atajos/graficas.png": 83430,
	"./atajos/graficas.webp": 2616,
	"./atajos/pomodoro.png": 19289,
	"./atajos/pomodoro.webp": 17717,
	"./atajos/rutasAprendizaje.png": 41508,
	"./atajos/rutasAprendizaje.webp": 98102,
	"./avatar.png": 75536,
	"./avatar2.png": 4192,
	"./avatar_gc.png": 40023,
	"./bachoco.png": 54636,
	"./back1.jpg": 37297,
	"./back2.jpg": 79526,
	"./back3.jpg": 18051,
	"./back4.jpg": 76400,
	"./back_perfiles.jpg": 54653,
	"./back_registro.jpg": 56960,
	"./background Asesor.png": 5068,
	"./background generic.jpg": 79492,
	"./bannerLectura.webp": 34571,
	"./bannerUveg.webp": 42496,
	"./bg-agendas-asesorias.jpg": 81741,
	"./bg-formulario-login.jpeg": 66594,
	"./bg-formulario-registro-mobile.jpeg": 71961,
	"./bg-formulario-registro.jpeg": 48744,
	"./calabazas.png": 17339,
	"./camara-de-video.png": 85642,
	"./capacitacion.jpg": 92480,
	"./capacitacion.png": 93284,
	"./cerrado.png": 1089,
	"./cerrado.webp": 35241,
	"./certificado.jpg": 66776,
	"./certiport-logo.png": 49421,
	"./chat-ia.png": 86082,
	"./chat-online.png": 86689,
	"./check.png": 52323,
	"./click.jpeg": 76756,
	"./click.png": 26403,
	"./click.webp": 31311,
	"./clickHalloween.png": 95046,
	"./clickMuertos.png": 33256,
	"./clickNavidad.png": 72748,
	"./competenciasLectura.jpg": 75564,
	"./competenciasLectura.png": 20712,
	"./competenciasLecturaPrimero.png": 11702,
	"./competenciasLecturaSegundo.png": 8427,
	"./compra/banner-form-promo.jpg": 59299,
	"./compra/banner-form-promo.webp": 5793,
	"./compra/compra-footer.jpg": 84322,
	"./compra/footer/logo-amex.png": 78381,
	"./compra/footer/logo-footer.png": 28081,
	"./compra/footer/logo-footer.webp": 14717,
	"./compra/footer/logo-mastercard.png": 74616,
	"./compra/footer/logo-visa.png": 31487,
	"./compra/mos/logo-certiport.png": 50320,
	"./compra/mos/logo-certiport.webp": 12466,
	"./compra/mos/mos-certification-logo.png": 36022,
	"./compra/mos/mos-certification-logo.webp": 58844,
	"./compra/mos/mos_cert.png": 43380,
	"./compra/mos/mos_cert.webp": 9946,
	"./compra/pckg_asesoria.jpg": 72645,
	"./compra/pckg_asesoria.png": 64533,
	"./compra/pckg_home_office.png": 36514,
	"./compra/pckg_office.jpg": 14736,
	"./compra/pckg_office.png": 81511,
	"./compra/pckg_premium.jpg": 10221,
	"./compra/pckg_premium.png": 77053,
	"./compra/pckg_self_improvement.jpg": 11923,
	"./configAndroid.png": 57308,
	"./consola-de-juego.png": 61399,
	"./consola-de-juego.webp": 1341,
	"./course-icons.png": 3233,
	"./creditos.png": 30118,
	"./cursoMos.jpg": 81888,
	"./custom_event.png": 40015,
	"./diaMuertosApariencia.png": 53961,
	"./dinoGame.png": 51521,
	"./dinoGame.webp": 6399,
	"./email.png": 60003,
	"./empleada.jpg": 35038,
	"./engranaje.png": 95668,
	"./equipo-trabajo.jpg": 67570,
	"./estudiando.jpg": 90901,
	"./f4f88ab2-1d3d-41e9-9a53-3f76a174a3dd.mp4": 56241,
	"./feedback.jpg": 89346,
	"./fondoGanadores.png": 40387,
	"./fondoLectura.png": 74803,
	"./fondoLectura.webp": 86881,
	"./formRegistro.jpg": 11742,
	"./foroAyuda.jpg": 20045,
	"./foroLectura/DocumentacionForoLectura.png": 32893,
	"./foto.jpg": 6261,
	"./foto.png": 85285,
	"./generadorTexto.png": 29114,
	"./generadorTexto.webp": 90590,
	"./general motors.png": 7345,
	"./gifs/searching.gif": 49300,
	"./git-etiquetas.png": 11910,
	"./globalClick.png": 64496,
	"./globalClick.webp": 85762,
	"./grafica.png": 69544,
	"./halloweenApariencia.png": 29093,
	"./headerLV.png": 25934,
	"./hotkeys.png": 63882,
	"./icons/analisisDatos.png": 35635,
	"./icons/examIcon.png": 33816,
	"./icons/excelMacrosIcon.png": 90245,
	"./icons/formatosWordIcon.png": 40198,
	"./icons/iconExcel.png": 63148,
	"./icons/photoshopIcon.png": 9471,
	"./icons/powerPointIcon.png": 53974,
	"./icons/projectManagement.png": 59146,
	"./icons/scratch.png": 43614,
	"./icons/scratchIcon.png": 15041,
	"./icons/teams.png": 91514,
	"./icons/unitedKingdom.png": 12724,
	"./icons/wordHome.png": 36287,
	"./icons/wordIcon.png": 59977,
	"./inicioSesion.png": 12077,
	"./introduccionoMovil.png": 98742,
	"./loginNuevo.webp": 34605,
	"./loginSim.png": 24655,
	"./logo-gc-horizontal.png": 64206,
	"./logoGCvertical.png": 9286,
	"./logoGCvertical.webp": 60034,
	"./logo_LV.png": 58993,
	"./logo_gc.jpeg": 16074,
	"./logo_grupo_empresarial.png": 12700,
	"./logos/logo-gc-certificado.png": 34174,
	"./logos/logotipo-Click-certificado.png": 17968,
	"./medalla-ganador.png": 70042,
	"./medalla-participante.png": 98514,
	"./memoramaGame.png": 8002,
	"./memoramaGame.webp": 38030,
	"./miniaturaAudio.gif": 71190,
	"./mobile-login-cover.jpg": 28403,
	"./modelo_relacional_plataforma.png": 74278,
	"./modelo_relacional_sim.png": 76604,
	"./navidad.png": 52052,
	"./navidadApariencia.png": 5999,
	"./nuevaAppClickHome.png": 76982,
	"./panelAdministracionIcons/753104-753103-753105--contrato.pdf": 98913,
	"./panelAdministracionIcons/KueskiPay_colores.png": 77089,
	"./panelAdministracionIcons/agenda-asesorias.png": 10284,
	"./panelAdministracionIcons/api.png": 90167,
	"./panelAdministracionIcons/contenido-web.png": 46835,
	"./panelAdministracionIcons/dashboard-lecciones.png": 38219,
	"./panelAdministracionIcons/estadisticas.png": 34734,
	"./panelAdministracionIcons/gestion-apariencia.png": 66462,
	"./panelAdministracionIcons/gestion-aula-virtual.png": 22916,
	"./panelAdministracionIcons/gestion-banco-preguntas.png": 20290,
	"./panelAdministracionIcons/gestion-consejos-rapidos.png": 8618,
	"./panelAdministracionIcons/gestion-contenido-cursos.png": 60056,
	"./panelAdministracionIcons/gestion-foro-ayuda.png": 38664,
	"./panelAdministracionIcons/gestion-lecciones.png": 96346,
	"./panelAdministracionIcons/gestion-licencias.png": 16412,
	"./panelAdministracionIcons/gestion-notificaciones.png": 80361,
	"./panelAdministracionIcons/gestion-rutas-aprendizaje.png": 75236,
	"./panelAdministracionIcons/gestion-usuarios.png": 57238,
	"./panelAdministracionIcons/info.png": 80355,
	"./panelAdministracionIcons/nuevo-estudiante.png": 42993,
	"./panelAdministracionIcons/plantillas-trabajo.png": 14297,
	"./panelAdministracionIcons/security.png": 81957,
	"./panelAdministracionIcons/suiteIa.png": 14865,
	"./papelpicado.png": 63449,
	"./plus.png": 75307,
	"./plus.webp": 53689,
	"./portadas-old/cursoAccess.png": 25238,
	"./portadas-old/cursoCanva.png": 66559,
	"./portadas-old/cursoExcelAplicado.png": 96454,
	"./portadas-old/cursoExcelBasico.png": 20134,
	"./portadas-old/cursoExcelIntermedio.png": 43383,
	"./portadas-old/cursoHangouts.png": 81543,
	"./portadas-old/cursoIngles.png": 85132,
	"./portadas-old/cursoInglesIntermediate.png": 16559,
	"./portadas-old/cursoInternet.png": 54995,
	"./portadas-old/cursoMeta.png": 51919,
	"./portadas-old/cursoOutlook.png": 70107,
	"./portadas-old/cursoPNL.png": 37536,
	"./portadas-old/cursoPhotoshop.png": 46138,
	"./portadas-old/cursoPowerBI-OLD.png": 20286,
	"./portadas-old/cursoPowerBI.png": 49114,
	"./portadas-old/cursoPowerBIAvanzado.png": 52894,
	"./portadas-old/cursoPowerPoint.png": 97439,
	"./portadas-old/cursoProject.png": 91485,
	"./portadas-old/cursoTeams.png": 47312,
	"./portadas-old/cursoWord.png": 80784,
	"./portadas-old/cursoWordpress.png": 40259,
	"./portadas-old/cursoZoom.png": 82337,
	"./portadas-old/default.jpg": 11703,
	"./portadas-old/examenDiagnostico.png": 22316,
	"./portadas-old/rutaDeAprendizaje1.png": 87189,
	"./portadas-old/rutasAprendizaje.png": 93102,
	"./portadas-old/scra.png": 9595,
	"./portadas-old/windows.png": 17875,
	"./portadas/CE25.png": 38733,
	"./portadas/CE25.webp": 99713,
	"./portadas/CL23.jpg": 31234,
	"./portadas/CL23.webp": 956,
	"./portadas/CP24.png": 30109,
	"./portadas/CP24.webp": 7249,
	"./portadas/CR23.png": 38872,
	"./portadas/CR23.webp": 28730,
	"./portadas/CV23.png": 3204,
	"./portadas/CV23.webp": 25398,
	"./portadas/EA16.png": 5665,
	"./portadas/EA16.webp": 64433,
	"./portadas/EBIN.png": 91074,
	"./portadas/EBIN.webp": 42132,
	"./portadas/EBMC.png": 30331,
	"./portadas/EBMC.webp": 48191,
	"./portadas/EI16.png": 90953,
	"./portadas/EI16.webp": 44489,
	"./portadas/EP24.png": 38599,
	"./portadas/EP24.webp": 47915,
	"./portadas/EX21.png": 13378,
	"./portadas/EX21.webp": 53660,
	"./portadas/EXMC.png": 14069,
	"./portadas/EXMC.webp": 73733,
	"./portadas/HANG.png": 61930,
	"./portadas/HANG.webp": 56520,
	"./portadas/ING1.png": 86427,
	"./portadas/ING1.webp": 19531,
	"./portadas/ING2.png": 8096,
	"./portadas/ING2.webp": 83466,
	"./portadas/ING3.jpg": 87041,
	"./portadas/ING3.webp": 34645,
	"./portadas/INTE.png": 36702,
	"./portadas/INTE.webp": 35740,
	"./portadas/LV.png": 36492,
	"./portadas/LV.webp": 37378,
	"./portadas/LV23.png": 67733,
	"./portadas/LV23.webp": 71017,
	"./portadas/MSTE.png": 66903,
	"./portadas/MSTE.webp": 46887,
	"./portadas/MT23.png": 8780,
	"./portadas/MT23.webp": 90162,
	"./portadas/MT25.png": 20922,
	"./portadas/MT25.webp": 12972,
	"./portadas/OU20.png": 63892,
	"./portadas/OU20.webp": 84862,
	"./portadas/PB21.png": 97095,
	"./portadas/PB21.webp": 13327,
	"./portadas/PBIA.png": 92414,
	"./portadas/PBIA.webp": 44284,
	"./portadas/PH18.png": 79233,
	"./portadas/PH18.webp": 77085,
	"./portadas/PNLB.png": 50014,
	"./portadas/PNLB.webp": 52560,
	"./portadas/PP16.png": 94791,
	"./portadas/PP16.webp": 29247,
	"./portadas/PP23.png": 79479,
	"./portadas/PP23.webp": 79639,
	"./portadas/PP25.png": 88929,
	"./portadas/PP25.webp": 63973,
	"./portadas/PR16.png": 5417,
	"./portadas/PR16.webp": 65157,
	"./portadas/PS25.png": 33078,
	"./portadas/PS25.webp": 68460,
	"./portadas/PSIA.png": 29179,
	"./portadas/PSIA.webp": 34227,
	"./portadas/PV24.png": 69582,
	"./portadas/PV24.webp": 49172,
	"./portadas/RC24.png": 35597,
	"./portadas/RC24.webp": 45621,
	"./portadas/SCRA.webp": 73079,
	"./portadas/VMIC.png": 41985,
	"./portadas/VMIC.webp": 44505,
	"./portadas/WI10.png": 40629,
	"./portadas/WI10.webp": 59105,
	"./portadas/WO16.png": 34433,
	"./portadas/WO16.webp": 57325,
	"./portadas/WOEN.png": 10517,
	"./portadas/WOEN.webp": 57113,
	"./portadas/WP21.png": 48660,
	"./portadas/WP21.webp": 9150,
	"./portadas/XLAM.png": 13608,
	"./portadas/XLAM.webp": 66810,
	"./portadas/ZOOM.png": 90779,
	"./portadas/ZOOM.webp": 21267,
	"./portadas/combinacionCorrespondencia.jpg": 48381,
	"./portadas/default.png": 19571,
	"./portadas/default.webp": 78049,
	"./portadas/ejercicioComplementario.jpg": 3442,
	"./portadas/examenDiagnostico.png": 37800,
	"./portadas/examenDiagnostico.webp": 99260,
	"./portadas/formatoCondicional.jpg": 20259,
	"./portadas/macrosWord.jpg": 63705,
	"./portadas/rutaDeAprendizaje1.png": 11017,
	"./portadas/rutaDeAprendizaje1.webp": 83837,
	"./portadas/rutasAprendizaje.png": 39218,
	"./portadas/rutasAprendizaje.webp": 32932,
	"./portadas/scra.png": 66879,
	"./portadas/solver.jpg": 71627,
	"./portadas/tablaPibote.jpg": 70605,
	"./portadas/tablasWord.jpg": 41721,
	"./portadas/tablasdinamicas.jpg": 99358,
	"./portadas/transposicionDatos.jpg": 81373,
	"./portadasReels/acomodar.png": 71247,
	"./portadasReels/autorelleno.png": 2569,
	"./portadasReels/buscarv.png": 80157,
	"./portadasReels/chatgpt.png": 7110,
	"./portadasReels/consecutivos.png": 23824,
	"./portadasReels/desplegables.png": 56076,
	"./portadasReels/engranes.png": 69216,
	"./portadasReels/filtros.png": 66178,
	"./portadasReels/formato.png": 93375,
	"./portadasReels/grabador.png": 52689,
	"./portadasReels/inmovilizar.png": 53849,
	"./portadasReels/menus.png": 41535,
	"./portadasReels/microsoft excel.png": 43126,
	"./portadasReels/pantalla.png": 74882,
	"./portadasReels/presentaciones.png": 83642,
	"./portadasReels/productividad.png": 7959,
	"./portadasReels/separar.png": 79699,
	"./portadasReels/tablas.png": 15912,
	"./portadasReels/whatsapp.png": 24761,
	"./portadasReels/zoom.png": 92002,
	"./portadas_rutasAprendizaje-old/Desarrollo Personal.png": 60946,
	"./portadas_rutasAprendizaje-old/Diseño.png": 34490,
	"./portadas_rutasAprendizaje-old/Home Office.png": 83568,
	"./portadas_rutasAprendizaje-old/Idiomas.jpg": 72623,
	"./portadas_rutasAprendizaje-old/Informática.png": 11226,
	"./portadas_rutasAprendizaje-old/Inteligencia de Ventas.jpg": 12999,
	"./portadas_rutasAprendizaje-old/Ofimatica.jpg": 99776,
	"./portadas_rutasAprendizaje-old/Programación.jpg": 401,
	"./portadas_rutasAprendizaje-old/miRutaAprendizaje.jpg": 35832,
	"./portadas_rutasAprendizaje/Commerce.png": 79166,
	"./portadas_rutasAprendizaje/Commerce.webp": 17938,
	"./portadas_rutasAprendizaje/Desarrollo Personal.png": 88694,
	"./portadas_rutasAprendizaje/Desarrollo Personal.webp": 57324,
	"./portadas_rutasAprendizaje/Diseño.png": 96702,
	"./portadas_rutasAprendizaje/Diseño.webp": 41142,
	"./portadas_rutasAprendizaje/Home Office.png": 13916,
	"./portadas_rutasAprendizaje/Home Office.webp": 49578,
	"./portadas_rutasAprendizaje/Idiomas.png": 89851,
	"./portadas_rutasAprendizaje/Idiomas.webp": 6243,
	"./portadas_rutasAprendizaje/Informática.png": 87046,
	"./portadas_rutasAprendizaje/Informática.webp": 5048,
	"./portadas_rutasAprendizaje/Inteligencia de Ventas.png": 47963,
	"./portadas_rutasAprendizaje/Inteligencia de Ventas.webp": 69297,
	"./portadas_rutasAprendizaje/Ofimatica.png": 88600,
	"./portadas_rutasAprendizaje/Ofimatica.webp": 68350,
	"./portadas_rutasAprendizaje/Programación.png": 88181,
	"./portadas_rutasAprendizaje/Programación.webp": 18099,
	"./portadas_rutasAprendizaje/miRutaAprendizaje.png": 81960,
	"./portadas_rutasAprendizaje/miRutaAprendizaje.webp": 62646,
	"./portadas_rutasAprendizaje/rutaPersonalizada.png": 81626,
	"./previewModulos/aula-virtual.png": 60098,
	"./previewModulos/barra-busqueda.png": 30766,
	"./previewModulos/certificacion-mos.png": 63996,
	"./previewModulos/certificados.png": 5393,
	"./previewModulos/consejos-rapidos.png": 41240,
	"./previewModulos/faq.png": 92287,
	"./previewModulos/foro-ayuda.png": 8438,
	"./previewModulos/foro-empresarial.png": 57969,
	"./previewModulos/historial-avances.png": 30028,
	"./previewModulos/historial-pagos.png": 92661,
	"./previewModulos/propedeutico-mos.png": 73846,
	"./previewModulos/ruta-aprendizaje.png": 6361,
	"./previewModulos/usuario-adicional.png": 76312,
	"./qaAppMovil.jpeg": 63696,
	"./qaAppMovil.png": 62583,
	"./qaAppMovilDark.png": 21779,
	"./qrClickplus.png": 33372,
	"./qrClickplusLarge.png": 20399,
	"./recursos_mos/contenido-mos.png": 28333,
	"./recursos_mos/contenido-mos.webp": 85683,
	"./recursos_mos/contenido-mos_old.png": 23115,
	"./recursos_mos/fondo_mos.png": 1444,
	"./recursos_mos/fondo_mos.webp": 51640,
	"./recursos_mos/fondo_mos_old.png": 69026,
	"./recursos_mos/logo_excel.png": 93619,
	"./recursos_mos/logo_excel.webp": 77159,
	"./recursos_mos/reseña_mos.png": 51041,
	"./recursos_mos/reseña_mos.webp": 74093,
	"./recursos_mos/reseña_mos2.png": 24231,
	"./recursos_mos/reseña_mos2.webp": 16957,
	"./recursos_mos/reseña_mos3.png": 36542,
	"./recursos_mos/reseña_mos3.webp": 30546,
	"./reseñas.png": 74611,
	"./seleccion-perfiles.jpg": 35969,
	"./signo-abierto.png": 54406,
	"./signo-abierto.webp": 94428,
	"./sin-dinero.png": 7491,
	"./sin-dinero.webp": 9297,
	"./sinApariencia.png": 27090,
	"./skill_plus.png": 4021,
	"./slideExample.jpg": 90548,
	"./slider-juegos.png": 22714,
	"./slider-misiones.png": 17910,
	"./slider-photoshop.png": 44603,
	"./slider1.png": 19767,
	"./slider2.png": 19132,
	"./sliderAppMovil.png": 48394,
	"./sliderNuevosCertificados.png": 46354,
	"./snakeGame.png": 20693,
	"./snakeGame.webp": 45765,
	"./texto.jpg": 53491,
	"./texto.png": 47227,
	"./textoAudio.png": 69853,
	"./textoAudio.webp": 56615,
	"./textoImagen.png": 90656,
	"./textoImagenTitulo.png": 3783,
	"./textoImagenTitulo.webp": 23024,
	"./trofeo.png": 77798,
	"./unnamed (2).jpg": 53020,
	"./unnamed.png": 82151,
	"./usuario.svg": 24929,
	"./uvegActualizado.png": 97427,
	"./video.png": 54170,
	"./voz.jpg": 71802,
	"./voz.png": 12478,
	"./zip-icon.png": 78362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;